import * as React from 'react';

export class BNDVCompletaRFResultadoSP extends React.Component {
    render() {
        var jsonObjectPesquisa = JSON.parse(this.props.data);
        var leiloes;

        if (JSON.stringify(jsonObjectPesquisa.leilao.leiloes) != null) {
            jsonObjectPesquisa.leilao = (jsonObjectPesquisa.leilao.leiloes == null ? [] : jsonObjectPesquisa.leilao.leiloes);
        }

        if (jsonObjectPesquisa.leilao.length == 0) {
            leiloes = <div className="row">
                <div className="col-md-2">&nbsp;</div>
                <div className="col-md-10">Não foram encontrados registros de oferta em leilão</div>
            </div>;
        }
        else {
            leiloes = jsonObjectPesquisa.leilao.map(function (rowData, index) {
                return <div key={index}>
                    <h4>Ocorrência {index + 1}</h4>
                    <div className="row">
                        <div className="col-md-2">Placa: </div>
                        <div className="col-md-4">{rowData.placa}</div>
                        <div className="col-md-2">Chassi: </div>
                        <div className="col-md-4">{rowData.chassi}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Marca: </div>
                        <div className="col-md-4">{rowData.marca}</div>
                        <div className="col-md-2">Modelo: </div>
                        <div className="col-md-4">{rowData.modelo}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Renavam: </div>
                        <div className="col-md-4">{rowData.renavam}</div>
                        <div className="col-md-2">Ano Modelo: </div>
                        <div className="col-md-4">{rowData.anoModelo}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Cor: </div>
                        <div className="col-md-4">{rowData.cor}</div>
                        <div className="col-md-2">Combustível: </div>
                        <div className="col-md-4">{rowData.combustivel}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Condição Veic: </div>
                        <div className="col-md-4">{rowData.condicaoVeiculo}</div>
                        <div className="col-md-2">Data Leilão: </div>
                        <div className="col-md-4">{rowData.dataLeilao}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">Comitente: </div>
                        <div className="col-md-4">{rowData.comitente}</div>
                        <div className="col-md-2">Lote: </div>
                        <div className="col-md-4">{rowData.lote}</div>
                    </div>
                </div>
            });
        }

        return <div>
            <div id="retorno-pesquisa">
                <h5 className="custom-font filled bg-blue">Dados do Veículo</h5>
                <div className="row">
                    <div className="col-md-2">Placa: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.placa}</div>
                    <div className="col-md-2">Chassi: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.chassi}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Município: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.municipio}</div>
                    <div className="col-md-2">Renavam: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.renavam}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Tipo: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.tipo}</div>
                    <div className="col-md-2">Combustível: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.combustivel}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Cor: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.cor}</div>
                    <div className="col-md-2">Marca: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.marca}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Categoria: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.categoria}</div>
                    <div className="col-md-2">Espécie: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.especie}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Ano Fab.: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.anoFabricacao}</div>
                    <div className="col-md-2">Ano Mod.: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.dadosVeiculo.anoModelo}</div>
                </div>
                <h5 className="custom-font filled bg-blue">Dados do Proprietário</h5>
                <div className="row">
                    <div className="col-md-2">Atual: </div>
                    <div className="col-md-10">{jsonObjectPesquisa.baseEstadual.dadosProprietario.nomeProprietario}</div>
                    <div className="col-md-2">Anterior: </div>
                    <div className="col-md-10">{jsonObjectPesquisa.baseEstadual.dadosProprietario.nomeProprietarioAnterior}</div>
                </div>
                <h5 className="custom-font filled bg-blue">Informações de Gravame</h5>
                <div className="row">
                    <div className="col-md-2">Restr.Financeira: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.gravames.restricaoFinanceira}</div>
                    <div className="col-md-2">Financeira: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.gravames.agente}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Arrendatário: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.gravames.arrendatarioFinanciado}</div>
                    <div className="col-md-2">CPF/CNPJ: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.gravames.cnpjcpfFinanc}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Data Inclusão: </div>
                    <div className="col-md-10">{jsonObjectPesquisa.baseEstadual.gravames.dataInclusaoFinanciamento}</div>
                </div>
                <h5 className="custom-font filled bg-blue">Informações de Intenção de Gravame</h5>
                <div className="row">
                    <div className="col-md-2">Restr.Financeira: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.intencaoGravame.restricaoFinanceira}</div>
                    <div className="col-md-2">Financeira: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.intencaoGravame.agenteFinanceiro}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Financiado: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.intencaoGravame.nomeFinanciado}</div>
                    <div className="col-md-2">CPF/CNPJ: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.intencaoGravame.cnpjcpfFinanc}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Data Inclusão: </div>
                    <div className="col-md-10">{jsonObjectPesquisa.baseEstadual.intencaoGravame.dataInclusao}</div>
                </div>
                <h5 className="custom-font filled bg-blue">Débitos / Multas</h5>
                <div className="row">
                    <div className="col-md-2">Dersa: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.dersa}</div>
                    <div className="col-md-2">Der: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.der}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Detran: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.detran}</div>
                    <div className="col-md-2">Cetesb: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.cetesb}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Renainf: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.renainf}</div>
                    <div className="col-md-2">Municipais: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.municipais}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Pol.Rod.Federal: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.policiaRodoviariaFederal}</div>
                    <div className="col-md-2">IPVA: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.debitoMultas.ipva}</div>
                </div>
                <h5 className="custom-font filled bg-blue">Restrições</h5>
                <div className="row">
                    <div className="col-md-2">Furto: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.restricoes.restricoesFurto}</div>
                    <div className="col-md-2">Bloq.Guincho: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.restricoes.bloqueioGuincho}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Administrativa: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.restricoes.restricoesAdministrativas}</div>
                    <div className="col-md-2">Judicial: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.restricoes.restricoesJudicial}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Tributária: </div>
                    <div className="col-md-10">{jsonObjectPesquisa.baseEstadual.restricoes.restricoesTributaria}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Renajud: </div>
                    <div className="col-md-10">{jsonObjectPesquisa.baseEstadual.restricoes.bloqueiosRenajud}</div>
                </div>
                <h5 className="custom-font filled bg-blue">Licenciamento</h5>
                <div className="row">
                    <div className="col-md-2">Exercício: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.crvCrlvAtualizacao.exercicioLicenciamento}</div>
                    <div className="col-md-2">Data Licenc.: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.crvCrlvAtualizacao.dataLicenciamento}</div>
                </div>
                <h5 className="custom-font filled bg-blue">Comunicação de Venda</h5>
                <div className="row">
                    <div className="col-md-2">Comunicado: </div>
                    <div className="col-md-10">{jsonObjectPesquisa.baseEstadual.comunicacaoVendas.comunicacao}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Data Inclusão: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.comunicacaoVendas.inclusao}</div>
                    <div className="col-md-2">Tipo Doc.Comp.: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.comunicacaoVendas.tipoDocumentoComprador}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">CNPJ/CPF Compr.: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.comunicacaoVendas.cnpjcpfComprador}</div>
                    <div className="col-md-2">Data Venda: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.comunicacaoVendas.dataVenda}</div>
                </div>
                <div className="row">
                    <div className="col-md-2">Data Nota Fiscal: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.comunicacaoVendas.dataNotaFiscal}</div>
                    <div className="col-md-2">Data Protocolo Detran: </div>
                    <div className="col-md-4">{jsonObjectPesquisa.baseEstadual.comunicacaoVendas.dataProtocoloDetran}</div>
                </div>
                <h5 className="custom-font filled bg-blue">BIN + Histórico de Roubo e Furto</h5>
                {
                    (jsonObjectPesquisa.binroubofurto.registrosRF != null)
                        ? (jsonObjectPesquisa.binroubofurto.registrosRF.length > 0)
                            ? <p className="text-lightred text-center mt-10"><strong>Foram encontrados registros de histórico de Roubo e Furto</strong></p>
                            : <p className="text-success text-center mt-10">Não foram encontrados registros de histórico de Roubo e Furto</p>
                        : <p className="text-success text-center mt-10">Não foram encontrados registros de histórico de Roubo e Furto</p>
                }
                {
                    (jsonObjectPesquisa.binroubofurto.registrosRF != null)
                        ? (jsonObjectPesquisa.binroubofurto.registrosRF.length > 0)
                            ? jsonObjectPesquisa.binroubofurto.registrosRF.map(function (rowData, index) {
                                return (
                                    <div key={index} className="mt-10">
                                        <div className="row">
                                            <div className="col-md-2">Placa: </div>
                                            <div className="col-md-4">{rowData.placa}</div>
                                            <div className="col-md-2">Tipo Ocorrência: </div>
                                            <div className="col-md-4">{rowData.tipoOcorrencia}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2">Chassi: </div>
                                            <div className="col-md-4">{rowData.chassi}</div>
                                            <div className="col-md-2">Modelo: </div>
                                            <div className="col-md-4">{rowData.marcaModelo}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2">Boletim: </div>
                                            <div className="col-md-4">{rowData.boletim}</div>
                                            <div className="col-md-2">Ano Boletim: </div>
                                            <div className="col-md-4">{rowData.anoBoletim}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2">Data Ocorrência: </div>
                                            <div className="col-md-4">{rowData.dataOcorrencia}</div>
                                            <div className="col-md-2">UF Ocorrência: </div>
                                            <div className="col-md-4">{rowData.ufOcorrencia}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2">Cidade: </div>
                                            <div className="col-md-4">{rowData.cidade}</div>
                                            <div className="col-md-2">Tipo Declaração: </div>
                                            <div className="col-md-4">{rowData.tipoDeclaracao}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2">Declaração: </div>
                                            <div className="col-md-4">{rowData.declaracao}</div>
                                            <div className="col-md-2">Nome Informante: </div>
                                            <div className="col-md-4">{rowData.nomeInformante}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-2">UF Placa: </div>
                                            <div className="col-md-4">{rowData.ufPlaca}</div>
                                            <div className="col-md-2">Município: </div>
                                            <div className="col-md-4">{rowData.municipioEmplacamento}</div>
                                        </div>
                                        <hr />
                                    </div>
                                )
                            })
                            : null
                        : null
                }
                <h5 className="custom-font filled bg-blue">Histórico de Oferta em Leilão</h5>
                {leiloes}
                <h5 className="custom-font filled bg-blue">Risco de Comercialização</h5>
                <div className="row">
                    <div className="col-md-2">Parecer: </div>
                    <div className="col-md-10">
                        {
                            (jsonObjectPesquisa.parecerSinistro != null)
                                ? (jsonObjectPesquisa.parecerSinistro.parecer.indiceParecer == 1)
                                    ? 'Não foram encontrados registros para avaliar o veículo'
                                    : (jsonObjectPesquisa.parecerSinistro.parecer.indiceParecer == 2)
                                        ? <p className="text-warning">{jsonObjectPesquisa.parecerSinistro.parecer.parecerHistorico}</p>
                                        : <p className="text-lightred">{jsonObjectPesquisa.parecerSinistro.parecer.parecerHistorico}</p>
                                : (jsonObjectPesquisa.leilao.length > 0)
                                    ? (jsonObjectPesquisa.leilao[0].nomeFoto1 == "01.jpg")
                                        ? "Risco baixo de comercialização"
                                        : (jsonObjectPesquisa.leilao[0].nomeFoto1 == "02.jpg")
                                            ? <p className="text-warning">Risco médio de comercialização</p>
                                            : (jsonObjectPesquisa.leilao[0].nomeFoto1 == "03.jpg")
                                                ? <p className="text-lightred">Risco alto de comercialização</p>
                                                : "Não foram encontrados registros para avaliar o veículo"
                                    : "Não foram encontrados registros para avaliar o veículo"
                        }
                    </div>
                </div>
            </div>
        </div>;
    }
}